<script lang="ts">
    export let name:string;
    export let options:string[];
    export let value:string;
    export let layout:Layouts = 'row';

    type Layouts = 'row' | 'column';

    import { createEventDispatcher } from 'svelte';

    let htmlNames = [];
    options.forEach((option, index) => {
        let htmlName = option.toLowerCase().replace(/\s/g, '-');
        htmlNames.push(htmlName);
    });

    const dispatch = createEventDispatcher();
    function inputChange() {
        value = this.value
		dispatch('message', {
			text: 'Hello, radio change!'
		});
    }

</script>

<div class="radio-area" class:column="{layout === 'column'}">
    {#each options as option, index}
        <div class="radio-option">
            <label for={htmlNames[index]}>
                <input type="radio" id={htmlNames[index]} name={name} bind:group={value} value={option} on:input={inputChange} />
                {option}
            </label>
        </div>
    {/each}
</div>


<style>
    .radio-area {
        display: flex;
        margin-bottom: 1rem;
        flex-wrap: wrap;
    }
    .radio-area.column {
        flex-direction: column;
    }
    .radio-option {
        margin-right: 1rem;
        border-radius: 8px;
    }
    .radio-option:hover {
        background: var(--background-offset);
    }
    input {
        width: 1.5rem;
        height: 1.5rem;
        padding: 1rem;
        margin: 0 0.5rem 0 0;
    }
    label {
        display: flex;
        padding: 1rem 1rem 1rem 0.5rem;
        align-items: center;
    }

</style>